var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C12.2761 4 12.5 4.22386 12.5 4.5V14.5429L15.3964 11.6464C15.5917 11.4512 15.9083 11.4512 16.1036 11.6464C16.2988 11.8417 16.2988 12.1583 16.1036 12.3536L12.3536 16.1036C12.1583 16.2988 11.8417 16.2988 11.6464 16.1036L7.89645 12.3536C7.70118 12.1583 7.70118 11.8417 7.89645 11.6464C8.09171 11.4512 8.40829 11.4512 8.60355 11.6464L11.5 14.5429V4.5C11.5 4.22386 11.7239 4 12 4ZM4.5 15.25C4.77614 15.25 5 15.4739 5 15.75V16.6875C5 17.3008 5.24364 17.889 5.67732 18.3227C6.11099 18.7564 6.69919 19 7.3125 19H16.6875C17.3008 19 17.889 18.7564 18.3227 18.3227C18.7564 17.889 19 17.3008 19 16.6875V15.75C19 15.4739 19.2239 15.25 19.5 15.25C19.7761 15.25 20 15.4739 20 15.75V16.6875C20 17.566 19.651 18.4086 19.0298 19.0298C18.4086 19.651 17.566 20 16.6875 20H7.3125C6.43397 20 5.59142 19.651 4.97021 19.0298C4.34899 18.4086 4 17.566 4 16.6875V15.75C4 15.4739 4.22386 15.25 4.5 15.25Z",
    fill: "#EA5449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3913382a3a35f3e69b691999ee3aecf1.svg";
export { ForwardRef as ReactComponent };